import type { SVGProps } from 'react'

function FazzBusinessSandboxLogo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={200} height={80} fill="none" {...props}>
      <path
        fill="#fff"
        d="M71.977 62.693c1.775 0 2.749-.687 2.749-1.952 0-.858-.46-1.502-1.2-1.674.565-.208.917-.779.917-1.446 0-1.131-.895-1.757-2.494-1.757-.723 0-1.52.134-2.16.343v6.138a7.117 7.117 0 0 0 2.188.348Zm-1.104-3.978v-1.827a4.025 4.025 0 0 1 1.201-.185c.835 0 1.275.357 1.275 1.034 0 .616-.394.978-1.09.978h-1.386Zm1.201 3.138a3.73 3.73 0 0 1-1.2-.185v-2.156h1.52c.788 0 1.233.413 1.233 1.14 0 .803-.514 1.201-1.553 1.201ZM77.876 62.693c.732 0 1.511-.135 2.063-.4v-4.71h-1.038v4.09c-.283.106-.682.18-1.025.18-.811 0-1.085-.422-1.085-1.066v-3.203h-1.038v3.203c0 1.238.755 1.906 2.123 1.906ZM82.57 62.693c1.177 0 1.896-.529 1.896-1.41 0-.737-.459-1.145-1.298-1.516l-.413-.18c-.44-.19-.681-.376-.681-.752 0-.384.273-.588.857-.588.302 0 .673.05 1.071.176l.135-.635c-.39-.186-.946-.292-1.382-.292-1.08 0-1.701.482-1.701 1.312 0 .676.39 1.126 1.08 1.432l.496.227c.543.223.816.427.816.812 0 .43-.399.662-1.07.662a3.51 3.51 0 0 1-1.15-.199l-.13.626a3.597 3.597 0 0 0 1.474.325ZM86.174 56.833c.357 0 .645-.25.645-.64 0-.371-.279-.626-.645-.626-.361 0-.644.255-.644.626 0 .38.287.64.644.64Zm-.524 5.771h1.039v-5.02H85.65v5.02ZM88.017 62.604h1.038V58.52a2.829 2.829 0 0 1 1.03-.185c.806 0 1.08.357 1.08.983v3.286h1.038v-3.24c0-1.2-.76-1.868-2.118-1.868-.724 0-1.484.185-2.068.528v4.58ZM97.87 59.855c0-1.539-.843-2.36-2.206-2.36-1.405 0-2.3.946-2.3 2.36v.478c0 1.46 1.002 2.36 2.485 2.36.543 0 1.16-.13 1.6-.32l-.135-.659a4.426 4.426 0 0 1-1.28.186c-1.01 0-1.603-.492-1.613-1.48h3.408c.023-.19.042-.37.042-.565Zm-1.043-.139h-2.406v-.102c0-.843.473-1.321 1.243-1.321.755 0 1.163.464 1.163 1.321v.102ZM100.409 62.693c1.177 0 1.896-.529 1.896-1.41 0-.737-.459-1.145-1.298-1.516l-.413-.18c-.44-.19-.681-.376-.681-.752 0-.384.273-.588.857-.588.302 0 .673.05 1.071.176l.135-.635c-.39-.186-.946-.292-1.382-.292-1.08 0-1.701.482-1.701 1.312 0 .676.39 1.126 1.08 1.432l.496.227c.542.223.816.427.816.812 0 .43-.399.662-1.071.662-.315 0-.765-.055-1.15-.199l-.13.626a3.597 3.597 0 0 0 1.475.325ZM104.797 62.693c1.177 0 1.896-.529 1.896-1.41 0-.737-.459-1.145-1.298-1.516l-.413-.18c-.44-.19-.681-.376-.681-.752 0-.384.273-.588.857-.588.302 0 .672.05 1.071.176l.135-.635c-.39-.186-.946-.292-1.382-.292-1.08 0-1.701.482-1.701 1.312 0 .676.389 1.126 1.08 1.432l.496.227c.542.223.816.427.816.812 0 .43-.399.662-1.071.662-.315 0-.765-.055-1.15-.199l-.13.626a3.599 3.599 0 0 0 1.475.325Z"
      />
      <path fill="#0000FA" d="M20.452 63a2.521 2.521 0 1 0 0-5.042 2.521 2.521 0 0 0 0 5.042Z" />
      <path
        fill="#0101FA"
        d="M20.558 62.864a2.546 2.546 0 1 0 0-5.092 2.546 2.546 0 0 0 0 5.092Z"
      />
      <path
        fill="#0102FA"
        d="M20.665 62.729a2.571 2.571 0 1 0 0-5.143 2.571 2.571 0 0 0 0 5.143Z"
      />
      <path
        fill="#0203F9"
        d="M20.772 62.593a2.596 2.596 0 1 0 0-5.193 2.596 2.596 0 0 0 0 5.193Z"
      />
      <path
        fill="#0204F9"
        d="M20.879 62.457a2.621 2.621 0 1 0-.001-5.242 2.621 2.621 0 0 0 0 5.242Z"
      />
      <path
        fill="#0305F9"
        d="M20.985 62.322a2.646 2.646 0 1 0 0-5.292 2.646 2.646 0 0 0 0 5.292Z"
      />
      <path fill="#0406F9" d="M21.09 62.187a2.671 2.671 0 1 0 0-5.343 2.671 2.671 0 0 0 0 5.343Z" />
      <path
        fill="#0407F8"
        d="M21.198 62.051a2.696 2.696 0 1 0 0-5.393 2.696 2.696 0 0 0 0 5.393Z"
      />
      <path
        fill="#0508F8"
        d="M21.305 61.915a2.721 2.721 0 1 0-.001-5.442 2.721 2.721 0 0 0 0 5.442Z"
      />
      <path fill="#0509F8" d="M21.411 61.78a2.746 2.746 0 1 0 0-5.493 2.746 2.746 0 0 0 0 5.493Z" />
      <path
        fill="#060AF8"
        d="M21.518 61.644a2.771 2.771 0 1 0 0-5.543 2.771 2.771 0 0 0 0 5.543Z"
      />
      <path
        fill="#070BF7"
        d="M21.625 61.508a2.796 2.796 0 1 0-.001-5.592 2.796 2.796 0 0 0 0 5.592Z"
      />
      <path fill="#070CF7" d="M21.731 61.373a2.82 2.82 0 1 0 0-5.642 2.82 2.82 0 0 0 0 5.642Z" />
      <path
        fill="#080DF7"
        d="M21.838 61.237a2.846 2.846 0 1 0 0-5.692 2.846 2.846 0 0 0 0 5.692Z"
      />
      <path fill="#080EF7" d="M21.944 61.102a2.87 2.87 0 1 0 0-5.742 2.87 2.87 0 0 0 0 5.742Z" />
      <path
        fill="#090FF6"
        d="M22.051 60.966a2.896 2.896 0 1 0 0-5.792 2.896 2.896 0 0 0 0 5.792Z"
      />
      <path fill="#0A10F6" d="M22.158 60.83a2.92 2.92 0 1 0-.001-5.842 2.92 2.92 0 0 0 0 5.842Z" />
      <path
        fill="#0A11F6"
        d="M22.264 60.694a2.946 2.946 0 1 0 0-5.891 2.946 2.946 0 0 0 0 5.892Z"
      />
      <path fill="#0B12F6" d="M22.37 60.559a2.97 2.97 0 1 0 0-5.942 2.97 2.97 0 0 0 0 5.942Z" />
      <path
        fill="#0B13F5"
        d="M22.478 60.424a2.996 2.996 0 1 0 0-5.992 2.996 2.996 0 0 0 0 5.992Z"
      />
      <path fill="#0C14F5" d="M22.584 60.288a3.02 3.02 0 1 0-.001-6.042 3.02 3.02 0 0 0 0 6.042Z" />
      <path fill="#0C15F5" d="M22.69 60.152a3.046 3.046 0 1 0 0-6.092 3.046 3.046 0 0 0 0 6.092Z" />
      <path
        fill="#0D16F5"
        d="M22.797 60.017a3.071 3.071 0 1 0 0-6.142 3.071 3.071 0 0 0 0 6.142Z"
      />
      <path
        fill="#0E17F4"
        d="M22.904 59.881a3.096 3.096 0 1 0-.001-6.192 3.096 3.096 0 0 0 0 6.192Z"
      />
      <path fill="#0E18F4" d="M23.01 59.745a3.12 3.12 0 1 0 0-6.24 3.12 3.12 0 0 0 0 6.24Z" />
      <path fill="#0F19F4" d="M23.117 59.61a3.145 3.145 0 1 0 0-6.29 3.145 3.145 0 0 0 0 6.29Z" />
      <path fill="#0F1AF4" d="M23.224 59.474a3.17 3.17 0 1 0-.001-6.34 3.17 3.17 0 0 0 0 6.34Z" />
      <path fill="#101BF3" d="M23.33 59.339a3.195 3.195 0 1 0 0-6.391 3.195 3.195 0 0 0 0 6.39Z" />
      <path fill="#111CF3" d="M23.437 59.203a3.22 3.22 0 1 0-.001-6.44 3.22 3.22 0 0 0 0 6.44Z" />
      <path
        fill="#111DF3"
        d="M23.544 59.067a3.246 3.246 0 1 0-.001-6.49 3.246 3.246 0 0 0 0 6.49Z"
      />
      <path fill="#121EF3" d="M23.65 58.932a3.27 3.27 0 1 0-.001-6.541 3.27 3.27 0 0 0 0 6.54Z" />
      <path
        fill="#121FF2"
        d="M23.757 58.796a3.296 3.296 0 1 0-.001-6.591 3.296 3.296 0 0 0 .001 6.591Z"
      />
      <path fill="#1320F2" d="M23.863 58.661a3.32 3.32 0 1 0 0-6.641 3.32 3.32 0 0 0 0 6.641Z" />
      <path fill="#1421F2" d="M23.97 58.525a3.346 3.346 0 1 0 0-6.691 3.346 3.346 0 0 0 0 6.691Z" />
      <path fill="#1422F2" d="M24.077 58.39a3.37 3.37 0 1 0-.001-6.742 3.37 3.37 0 0 0 0 6.742Z" />
      <path
        fill="#1523F1"
        d="M24.183 58.254a3.396 3.396 0 1 0-.001-6.791 3.396 3.396 0 0 0 0 6.791Z"
      />
      <path fill="#1524F1" d="M24.29 58.118a3.42 3.42 0 1 0-.001-6.84 3.42 3.42 0 0 0 0 6.84Z" />
      <path fill="#1625F1" d="M24.396 57.982a3.445 3.445 0 1 0 0-6.89 3.445 3.445 0 0 0 0 6.89Z" />
      <path fill="#1726F1" d="M24.503 57.846a3.47 3.47 0 1 0-.001-6.94 3.47 3.47 0 0 0 0 6.94Z" />
      <path
        fill="#1727F0"
        d="M24.61 57.711a3.495 3.495 0 1 0-.002-6.99 3.495 3.495 0 0 0 .001 6.99Z"
      />
      <path fill="#1828F0" d="M24.716 57.576a3.52 3.52 0 1 0 0-7.04 3.52 3.52 0 0 0 0 7.04Z" />
      <path
        fill="#1829F0"
        d="M24.823 57.44a3.545 3.545 0 1 0-.001-7.09 3.545 3.545 0 0 0 0 7.09Z"
      />
      <path fill="#192AF0" d="M24.93 57.304a3.57 3.57 0 1 0-.002-7.14 3.57 3.57 0 0 0 .001 7.14Z" />
      <path
        fill="#1A2BEF"
        d="M25.036 57.169a3.595 3.595 0 1 0-.001-7.19 3.595 3.595 0 0 0 .001 7.19Z"
      />
      <path fill="#1A2CEF" d="M25.143 57.033a3.62 3.62 0 1 0-.001-7.24 3.62 3.62 0 0 0 0 7.24Z" />
      <path
        fill="#1B2DEF"
        d="M25.25 56.897a3.645 3.645 0 1 0-.002-7.29 3.645 3.645 0 0 0 .001 7.29Z"
      />
      <path fill="#1B2EEF" d="M25.356 56.762a3.67 3.67 0 1 0 0-7.34 3.67 3.67 0 0 0 0 7.34Z" />
      <path
        fill="#1C2FEE"
        d="M25.463 56.627a3.695 3.695 0 1 0-.001-7.39 3.695 3.695 0 0 0 0 7.39Z"
      />
      <path fill="#1D30EE" d="M25.57 56.49a3.72 3.72 0 1 0-.002-7.439 3.72 3.72 0 0 0 .001 7.44Z" />
      <path fill="#1D31EE" d="M25.675 56.355a3.744 3.744 0 1 0 0-7.49 3.744 3.744 0 0 0 0 7.49Z" />
      <path fill="#1E32EE" d="M25.782 56.219a3.77 3.77 0 1 0 0-7.54 3.77 3.77 0 0 0 0 7.54Z" />
      <path
        fill="#1E32ED"
        d="M25.889 56.084a3.795 3.795 0 1 0-.001-7.59 3.795 3.795 0 0 0 0 7.59Z"
      />
      <path fill="#1F33ED" d="M25.995 55.948a3.82 3.82 0 1 0 0-7.64 3.82 3.82 0 0 0 0 7.64Z" />
      <path
        fill="#1F34ED"
        d="M26.102 55.813a3.845 3.845 0 1 0-.001-7.69 3.845 3.845 0 0 0 0 7.69Z"
      />
      <path
        fill="#2035ED"
        d="M26.209 55.677a3.87 3.87 0 1 0-.002-7.74 3.87 3.87 0 0 0 .002 7.74Z"
      />
      <path
        fill="#2136EC"
        d="M26.315 55.541a3.895 3.895 0 1 0-.001-7.789 3.895 3.895 0 0 0 .001 7.79Z"
      />
      <path
        fill="#2137EC"
        d="M26.422 55.406a3.92 3.92 0 1 0-.002-7.84 3.92 3.92 0 0 0 .002 7.84Z"
      />
      <path
        fill="#2238EC"
        d="M26.529 55.27a3.945 3.945 0 1 0-.001-7.89 3.945 3.945 0 0 0 0 7.89Z"
      />
      <path
        fill="#2239EC"
        d="M26.635 55.134a3.97 3.97 0 1 0-.001-7.94 3.97 3.97 0 0 0 .001 7.94Z"
      />
      <path
        fill="#233AEB"
        d="M26.742 54.999a3.995 3.995 0 1 0-.001-7.99 3.995 3.995 0 0 0 0 7.99Z"
      />
      <path
        fill="#243BEB"
        d="M26.848 54.863a4.02 4.02 0 1 0-.001-8.038 4.02 4.02 0 0 0 .001 8.038Z"
      />
      <path
        fill="#243CEB"
        d="M26.955 54.727a4.044 4.044 0 1 0-.001-8.088 4.044 4.044 0 0 0 .001 8.088Z"
      />
      <path fill="#253DEB" d="M27.062 54.592a4.07 4.07 0 1 0-.001-8.139 4.07 4.07 0 0 0 0 8.139Z" />
      <path
        fill="#253EEA"
        d="M27.168 54.456a4.094 4.094 0 1 0 0-8.188 4.094 4.094 0 0 0 0 8.188Z"
      />
      <path fill="#263FEA" d="M27.274 54.32a4.12 4.12 0 1 0 0-8.238 4.12 4.12 0 0 0 0 8.239Z" />
      <path
        fill="#2740EA"
        d="M27.381 54.185a4.144 4.144 0 1 0-.001-8.289 4.144 4.144 0 0 0 .001 8.289Z"
      />
      <path fill="#2741EA" d="M27.488 54.05a4.17 4.17 0 1 0-.002-8.34 4.17 4.17 0 0 0 .002 8.34Z" />
      <path
        fill="#2842E9"
        d="M27.595 53.914a4.194 4.194 0 1 0-.002-8.388 4.194 4.194 0 0 0 .002 8.388Z"
      />
      <path
        fill="#2843E9"
        d="M27.701 53.779a4.22 4.22 0 1 0-.001-8.44 4.22 4.22 0 0 0 .001 8.44Z"
      />
      <path
        fill="#2944E9"
        d="M27.808 53.643a4.244 4.244 0 1 0-.002-8.489 4.244 4.244 0 0 0 .002 8.489Z"
      />
      <path fill="#2A45E9" d="M27.914 53.507a4.27 4.27 0 1 0 0-8.538 4.27 4.27 0 0 0 0 8.538Z" />
      <path fill="#2A46E8" d="M28.02 53.372a4.294 4.294 0 1 0 0-8.59 4.294 4.294 0 0 0 0 8.59Z" />
      <path
        fill="#2B47E8"
        d="M28.128 53.235a4.319 4.319 0 1 0-.002-8.637 4.319 4.319 0 0 0 .002 8.637Z"
      />
      <path
        fill="#2B48E8"
        d="M28.234 53.1a4.344 4.344 0 1 0-.001-8.688 4.344 4.344 0 0 0 .001 8.688Z"
      />
      <path fill="#2C49E8" d="M28.34 52.965a4.369 4.369 0 1 0 0-8.738 4.369 4.369 0 0 0 0 8.738Z" />
      <path
        fill="#2D4AE7"
        d="M28.448 52.829a4.394 4.394 0 0 0 4.393-4.395 4.394 4.394 0 1 0-4.393 4.395Z"
      />
      <path
        fill="#2D4BE7"
        d="M28.554 52.693a4.419 4.419 0 1 0 0-8.837 4.419 4.419 0 0 0 0 8.837Z"
      />
      <path
        fill="#2E4CE7"
        d="M28.661 52.557a4.444 4.444 0 1 0-.001-8.887 4.444 4.444 0 0 0 .001 8.887Z"
      />
      <path
        fill="#2E4DE7"
        d="M28.767 52.422a4.469 4.469 0 1 0 0-8.938 4.469 4.469 0 0 0 0 8.938Z"
      />
      <path
        fill="#2F4EE6"
        d="M28.874 52.286a4.494 4.494 0 1 0-.002-8.988 4.494 4.494 0 0 0 .002 8.988Z"
      />
      <path
        fill="#304FE6"
        d="M28.98 52.15a4.519 4.519 0 1 0-.001-9.037 4.519 4.519 0 0 0 .001 9.038Z"
      />
      <path
        fill="#3050E6"
        d="M29.087 52.016a4.544 4.544 0 1 0-.002-9.088 4.544 4.544 0 0 0 .002 9.088Z"
      />
      <path
        fill="#3151E6"
        d="M29.194 51.88a4.569 4.569 0 1 0-.001-9.14 4.569 4.569 0 0 0 0 9.14Z"
      />
      <path fill="#3152E5" d="M29.3 51.744a4.594 4.594 0 1 0 0-9.188 4.594 4.594 0 0 0 0 9.188Z" />
      <path
        fill="#3253E5"
        d="M29.407 51.608a4.618 4.618 0 0 0 4.617-4.619 4.618 4.618 0 1 0-4.617 4.619Z"
      />
      <path
        fill="#3254E5"
        d="M29.513 51.472a4.643 4.643 0 0 0 4.643-4.644 4.643 4.643 0 1 0-4.643 4.644Z"
      />
      <path
        fill="#3355E5"
        d="M29.62 51.337a4.668 4.668 0 0 0 4.668-4.67 4.668 4.668 0 1 0-4.668 4.67Z"
      />
      <path
        fill="#3456E4"
        d="M29.727 51.202a4.693 4.693 0 0 0 4.693-4.695 4.693 4.693 0 1 0-4.693 4.695Z"
      />
      <path
        fill="#3457E4"
        d="M29.834 51.066a4.718 4.718 0 0 0 4.717-4.72 4.718 4.718 0 1 0-4.718 4.72Z"
      />
      <path
        fill="#3558E4"
        d="M29.94 50.93a4.744 4.744 0 0 0 4.743-4.744 4.743 4.743 0 1 0-4.743 4.744Z"
      />
      <path
        fill="#3559E4"
        d="M30.047 50.795a4.769 4.769 0 0 0 4.767-4.77 4.768 4.768 0 1 0-4.767 4.77Z"
      />
      <path
        fill="#365AE3"
        d="M30.154 50.659a4.793 4.793 0 0 0 4.792-4.794 4.793 4.793 0 1 0-4.792 4.794Z"
      />
      <path
        fill="#375BE3"
        d="M30.26 50.523a4.819 4.819 0 0 0 4.818-4.819 4.818 4.818 0 1 0-4.818 4.82Z"
      />
      <path
        fill="#375CE3"
        d="M30.366 50.388a4.844 4.844 0 0 0 4.843-4.845 4.843 4.843 0 1 0-4.843 4.845Z"
      />
      <path
        fill="#385DE3"
        d="M30.473 50.253a4.869 4.869 0 0 0 4.868-4.87 4.869 4.869 0 1 0-4.868 4.87Z"
      />
      <path
        fill="#385EE2"
        d="M30.58 50.116a4.893 4.893 0 0 0 4.891-4.893 4.893 4.893 0 1 0-4.892 4.893Z"
      />
      <path
        fill="#395FE2"
        d="M30.686 49.98a4.918 4.918 0 0 0 4.917-4.918 4.918 4.918 0 1 0-4.917 4.919Z"
      />
      <path
        fill="#3A60E2"
        d="M30.793 49.845a4.943 4.943 0 0 0 4.942-4.944 4.943 4.943 0 1 0-4.942 4.944Z"
      />
      <path
        fill="#3A61E2"
        d="M30.9 49.71a4.968 4.968 0 0 0 4.967-4.97 4.968 4.968 0 1 0-4.968 4.97Z"
      />
      <path
        fill="#3B62E1"
        d="M31.006 49.574a4.993 4.993 0 0 0 4.992-4.994 4.993 4.993 0 1 0-4.992 4.994Z"
      />
      <path
        fill="#3B63E1"
        d="M31.113 49.438a5.018 5.018 0 0 0 5.017-5.019 5.018 5.018 0 1 0-5.018 5.02Z"
      />
      <path
        fill="#3C64E1"
        d="M31.22 49.303a5.043 5.043 0 0 0 5.041-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#3B65E1"
        d="M30.97 49.303a5.043 5.043 0 0 0 5.043-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#3A66E2"
        d="M30.721 49.303a5.043 5.043 0 0 0 5.043-5.044 5.043 5.043 0 1 0-5.043 5.044Z"
      />
      <path
        fill="#3967E2"
        d="M30.473 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.043 5.044Z"
      />
      <path
        fill="#3868E3"
        d="M30.224 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#3769E3"
        d="M29.975 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#366AE4"
        d="M29.726 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#356BE4"
        d="M29.478 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#346CE5"
        d="M29.229 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#336DE5"
        d="M28.98 49.303a5.043 5.043 0 0 0 5.043-5.044 5.043 5.043 0 1 0-5.043 5.044Z"
      />
      <path
        fill="#326EE6"
        d="M28.731 49.303a5.043 5.043 0 0 0 5.043-5.044 5.043 5.043 0 1 0-5.043 5.044Z"
      />
      <path
        fill="#316FE6"
        d="M28.483 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#3070E7"
        d="M28.234 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#2F71E7"
        d="M27.985 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#2E72E8"
        d="M27.736 49.303a5.043 5.043 0 0 0 5.043-5.044 5.043 5.043 0 1 0-5.043 5.044Z"
      />
      <path
        fill="#2D73E8"
        d="M27.487 49.303a5.043 5.043 0 0 0 5.043-5.044 5.043 5.043 0 1 0-5.043 5.044Z"
      />
      <path
        fill="#2C74E9"
        d="M27.238 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#2B75E9"
        d="M26.99 49.303a5.043 5.043 0 0 0 5.041-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#2A76EA"
        d="M26.74 49.303a5.043 5.043 0 0 0 5.043-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#2977EA"
        d="M26.492 49.303a5.043 5.043 0 0 0 5.043-5.044 5.043 5.043 0 1 0-5.043 5.044Z"
      />
      <path
        fill="#2878EB"
        d="M26.244 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.043 5.044Z"
      />
      <path
        fill="#2779EB"
        d="M25.994 49.303a5.043 5.043 0 0 0 5.043-5.044 5.043 5.043 0 1 0-5.043 5.044Z"
      />
      <path
        fill="#267AEC"
        d="M25.745 49.303a5.043 5.043 0 0 0 5.043-5.044 5.043 5.043 0 1 0-5.043 5.044Z"
      />
      <path
        fill="#257BEC"
        d="M25.497 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#247CED"
        d="M25.248 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#237DED"
        d="M25 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.043 5.044Z"
      />
      <path
        fill="#227EEE"
        d="M24.75 49.303a5.043 5.043 0 0 0 5.043-5.044 5.043 5.043 0 1 0-5.043 5.044Z"
      />
      <path
        fill="#217FEE"
        d="M24.501 49.303a5.043 5.043 0 0 0 5.043-5.044 5.043 5.043 0 1 0-5.043 5.044Z"
      />
      <path
        fill="#2080EF"
        d="M24.253 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#1F81EF"
        d="M24.004 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#1E82F0"
        d="M23.755 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#1E82F0"
        d="M23.507 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#1D83F1"
        d="M23.258 49.303A5.043 5.043 0 0 0 28.3 44.26a5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#1C84F1"
        d="M23.01 49.303a5.043 5.043 0 0 0 5.041-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#1B85F2"
        d="M22.76 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#1A86F2"
        d="M22.511 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#1987F3"
        d="M22.262 49.303a5.043 5.043 0 0 0 5.043-5.044 5.043 5.043 0 1 0-5.043 5.044Z"
      />
      <path
        fill="#1888F3"
        d="M22.014 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.043 5.044Z"
      />
      <path
        fill="#1789F4"
        d="M21.765 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#168AF4"
        d="M21.516 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#158BF5"
        d="M21.267 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#148CF5"
        d="M21.018 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#138DF6"
        d="M20.77 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.043 5.044Z"
      />
      <path
        fill="#128EF6"
        d="M20.52 49.303a5.043 5.043 0 0 0 5.043-5.044 5.043 5.043 0 1 0-5.043 5.044Z"
      />
      <path
        fill="#118FF7"
        d="M20.272 49.303a5.043 5.043 0 0 0 5.043-5.044 5.043 5.043 0 1 0-5.043 5.044Z"
      />
      <path
        fill="#1090F7"
        d="M20.023 49.303a5.043 5.043 0 0 0 5.043-5.044 5.043 5.043 0 1 0-5.043 5.044Z"
      />
      <path
        fill="#0F91F8"
        d="M19.774 49.303a5.043 5.043 0 0 0 5.043-5.044 5.043 5.043 0 1 0-5.043 5.044Z"
      />
      <path
        fill="#0E92F8"
        d="M19.526 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#0D93F9"
        d="M19.277 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#0C94F9"
        d="M19.028 49.303a5.043 5.043 0 0 0 5.043-5.044 5.043 5.043 0 1 0-5.043 5.044Z"
      />
      <path
        fill="#0B95FA"
        d="M18.78 49.303a5.043 5.043 0 0 0 5.041-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#0A96FA"
        d="M18.53 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#0997FB"
        d="M18.282 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#0898FB"
        d="M18.032 49.303a5.043 5.043 0 0 0 5.043-5.044 5.043 5.043 0 1 0-5.043 5.044Z"
      />
      <path
        fill="#0799FC"
        d="M17.784 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.043 5.044Z"
      />
      <path
        fill="#069AFC"
        d="M17.535 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#059BFD"
        d="M17.287 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.043 5.044Z"
      />
      <path
        fill="#049CFD"
        d="M17.038 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#039DFE"
        d="M16.789 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#029EFE"
        d="M16.54 49.303a5.043 5.043 0 0 0 5.042-5.044 5.043 5.043 0 1 0-5.042 5.044Z"
      />
      <path
        fill="#019FFF"
        d="M16.291 49.303a5.043 5.043 0 0 0 5.043-5.044 5.043 5.043 0 1 0-5.043 5.044Z"
      />
      <path
        fill="#00A0FF"
        d="M16.042 49.303a5.043 5.043 0 0 0 5.043-5.044 5.043 5.043 0 1 0-5.043 5.044Z"
      />
      <path
        fill="#00A1FE"
        d="M16.357 48.926c2.817 0 5.1-2.284 5.1-5.102a5.102 5.102 0 1 0-5.1 5.102Z"
      />
      <path fill="#00A2FD" d="M16.672 48.55a5.16 5.16 0 0 0 5.16-5.16 5.16 5.16 0 1 0-5.16 5.16Z" />
      <path
        fill="#00A2FC"
        d="M16.987 48.174a5.219 5.219 0 0 0 5.218-5.22 5.219 5.219 0 1 0-5.218 5.22Z"
      />
      <path
        fill="#00A3FB"
        d="M17.302 47.798a5.277 5.277 0 0 0 5.276-5.278 5.277 5.277 0 1 0-5.276 5.278Z"
      />
      <path
        fill="#00A4FA"
        d="M17.616 47.422a5.336 5.336 0 0 0 5.336-5.336 5.336 5.336 0 1 0-5.336 5.336Z"
      />
      <path
        fill="#00A5F9"
        d="M17.931 47.046a5.395 5.395 0 0 0 5.394-5.395 5.395 5.395 0 1 0-5.394 5.395Z"
      />
      <path
        fill="#00A5F8"
        d="M18.246 46.67a5.453 5.453 0 0 0 5.452-5.454 5.453 5.453 0 1 0-5.452 5.454Z"
      />
      <path
        fill="#00A6F7"
        d="M18.56 46.294a5.512 5.512 0 0 0 5.511-5.513 5.512 5.512 0 1 0-11.022 0 5.512 5.512 0 0 0 5.511 5.513Z"
      />
      <path
        fill="#00A7F6"
        d="M18.875 45.918a5.571 5.571 0 0 0 5.57-5.572 5.571 5.571 0 1 0-5.57 5.572Z"
      />
      <path fill="#00A8F5" d="M19.19 45.542a5.63 5.63 0 0 0 5.63-5.63 5.63 5.63 0 1 0-5.63 5.63Z" />
      <path
        fill="#00A8F4"
        d="M19.505 45.166a5.688 5.688 0 0 0 5.688-5.689 5.688 5.688 0 1 0-5.688 5.69Z"
      />
      <path
        fill="#00A9F3"
        d="M19.82 44.79a5.747 5.747 0 0 0 5.746-5.748 5.747 5.747 0 1 0-11.492 0 5.747 5.747 0 0 0 5.746 5.748Z"
      />
      <path
        fill="#00AAF2"
        d="M20.135 44.414c3.206 0 5.804-2.6 5.804-5.806a5.805 5.805 0 1 0-11.609 0 5.806 5.806 0 0 0 5.805 5.806Z"
      />
      <path
        fill="#00ABF1"
        d="M20.45 44.038a5.864 5.864 0 0 0 5.863-5.865 5.864 5.864 0 1 0-11.727 0 5.864 5.864 0 0 0 5.863 5.865Z"
      />
      <path
        fill="#00ACF0"
        d="M20.764 43.661a5.923 5.923 0 0 0 5.922-5.923 5.923 5.923 0 1 0-11.844 0 5.923 5.923 0 0 0 5.922 5.923Z"
      />
      <path
        fill="#00ACEF"
        d="M21.079 43.285a5.981 5.981 0 0 0 5.98-5.982 5.981 5.981 0 1 0-11.96 0 5.981 5.981 0 0 0 5.98 5.982Z"
      />
      <path
        fill="#00ADEE"
        d="M21.394 42.91a6.04 6.04 0 0 0 6.04-6.042 6.04 6.04 0 1 0-12.079 0 6.04 6.04 0 0 0 6.039 6.041Z"
      />
      <path
        fill="#00AEED"
        d="M21.709 42.533a6.099 6.099 0 0 0 6.098-6.1 6.099 6.099 0 1 0-12.196 0c0 3.37 2.73 6.1 6.098 6.1Z"
      />
      <path
        fill="#00AFEC"
        d="M22.023 42.157c3.4 0 6.157-2.757 6.157-6.158a6.157 6.157 0 1 0-12.313 0 6.157 6.157 0 0 0 6.156 6.158Z"
      />
      <path
        fill="#00AFEB"
        d="M22.338 41.781a6.216 6.216 0 0 0 6.215-6.216 6.216 6.216 0 1 0-12.43 0 6.216 6.216 0 0 0 6.215 6.216Z"
      />
      <path
        fill="#00B0EA"
        d="M22.653 41.405a6.274 6.274 0 0 0 6.273-6.275 6.274 6.274 0 1 0-12.547 0 6.274 6.274 0 0 0 6.274 6.275Z"
      />
      <path
        fill="#00B1EA"
        d="M22.967 41.029a6.333 6.333 0 0 0 6.332-6.334 6.333 6.333 0 1 0-12.664 0 6.333 6.333 0 0 0 6.332 6.334Z"
      />
      <path
        fill="#00B2E9"
        d="M23.282 40.653c3.53 0 6.39-2.862 6.39-6.393a6.391 6.391 0 1 0-12.78 0 6.392 6.392 0 0 0 6.39 6.393Z"
      />
      <path
        fill="#00B2E8"
        d="M23.598 40.276a6.45 6.45 0 0 0 6.449-6.45 6.45 6.45 0 1 0-12.899 0 6.45 6.45 0 0 0 6.45 6.45Z"
      />
      <path
        fill="#00B3E7"
        d="M23.912 39.9a6.509 6.509 0 0 0 6.508-6.51 6.509 6.509 0 1 0-13.016 0 6.509 6.509 0 0 0 6.508 6.51Z"
      />
      <path
        fill="#00B4E6"
        d="M24.227 39.525a6.567 6.567 0 0 0 6.566-6.569 6.567 6.567 0 1 0-13.132 0 6.567 6.567 0 0 0 6.566 6.569Z"
      />
      <path
        fill="#00B5E5"
        d="M24.542 39.149a6.627 6.627 0 0 0 6.625-6.627 6.627 6.627 0 1 0-13.251 0 6.627 6.627 0 0 0 6.626 6.627Z"
      />
      <path
        fill="#00B5E4"
        d="M24.856 38.773a6.685 6.685 0 0 0 6.684-6.686 6.685 6.685 0 1 0-13.368 0 6.685 6.685 0 0 0 6.684 6.686Z"
      />
      <path
        fill="#00B6E3"
        d="M25.171 38.396a6.744 6.744 0 0 0 6.743-6.745 6.744 6.744 0 1 0-13.486 0 6.744 6.744 0 0 0 6.743 6.745Z"
      />
      <path
        fill="#00B7E2"
        d="M25.486 38.02a6.802 6.802 0 0 0 6.802-6.803 6.802 6.802 0 1 0-13.603 0 6.802 6.802 0 0 0 6.802 6.803Z"
      />
      <path
        fill="#00B8E1"
        d="M25.8 37.644a6.861 6.861 0 0 0 6.861-6.862 6.861 6.861 0 1 0-13.72 0 6.861 6.861 0 0 0 6.86 6.862Z"
      />
      <path
        fill="#00B9E0"
        d="M26.116 37.268a6.92 6.92 0 0 0 6.919-6.92 6.92 6.92 0 1 0-13.838 0 6.92 6.92 0 0 0 6.919 6.92Z"
      />
      <path
        fill="#00B9DF"
        d="M26.43 36.892a6.978 6.978 0 0 0 6.977-6.98 6.978 6.978 0 1 0-13.954 0 6.978 6.978 0 0 0 6.977 6.98Z"
      />
      <path
        fill="#00BADE"
        d="M26.745 36.516a7.037 7.037 0 0 0 7.036-7.038 7.037 7.037 0 1 0-14.072 0 7.037 7.037 0 0 0 7.036 7.038Z"
      />
      <path
        fill="#0BD"
        d="M27.06 36.14a7.095 7.095 0 0 0 7.094-7.096 7.095 7.095 0 1 0-14.189 0 7.095 7.095 0 0 0 7.095 7.096Z"
      />
      <path
        fill="#00BCDC"
        d="M27.375 35.763a7.154 7.154 0 0 0 7.153-7.155 7.154 7.154 0 1 0-14.306 0 7.154 7.154 0 0 0 7.153 7.155Z"
      />
      <path
        fill="#00BCDB"
        d="M27.69 35.388a7.213 7.213 0 0 0 7.212-7.214 7.213 7.213 0 1 0-14.424 0 7.213 7.213 0 0 0 7.212 7.214Z"
      />
      <path
        fill="#00BDDA"
        d="M28.005 35.011a7.271 7.271 0 0 0 7.27-7.272 7.271 7.271 0 1 0-14.54 0 7.271 7.271 0 0 0 7.27 7.272Z"
      />
      <path
        fill="#00BED9"
        d="M28.319 34.636a7.33 7.33 0 0 0 7.329-7.331 7.33 7.33 0 1 0-14.658 0 7.33 7.33 0 0 0 7.329 7.33Z"
      />
      <path
        fill="#00BFD8"
        d="M28.634 34.26a7.388 7.388 0 0 0 7.387-7.39 7.388 7.388 0 1 0-14.774 0 7.388 7.388 0 0 0 7.387 7.39Z"
      />
      <path
        fill="#00BFD7"
        d="M28.948 33.883a7.447 7.447 0 0 0 7.446-7.448 7.447 7.447 0 1 0-14.892 0 7.447 7.447 0 0 0 7.446 7.448Z"
      />
      <path
        fill="#00C0D6"
        d="M29.263 33.507a7.506 7.506 0 0 0 7.505-7.506 7.506 7.506 0 1 0-15.01 0 7.506 7.506 0 0 0 7.505 7.506Z"
      />
      <path
        fill="#00C1D5"
        d="M29.579 33.13a7.564 7.564 0 0 0 7.563-7.565 7.564 7.564 0 1 0-15.126 0 7.564 7.564 0 0 0 7.563 7.566Z"
      />
      <g fill="#fff" clipPath="url(#a)">
        <path d="m63.709 32.989-8.89 19.129h4.847l1.616-3.688h6.493l.438 3.688h4.902l-2.713-18.585a1.97 1.97 0 0 0-1.956-1.687h-2.945a1.98 1.98 0 0 0-1.792 1.143Zm-.647 11.206 3.45-8.305.823 8.305h-4.273Zm-16.267 8.026 1.217-7.424 7.203-.246.63-3.745-7.178-.218.41-2.677c.091-.565.274-.984.548-1.257.275-.273.714-.41 1.318-.41h6.927l.63-3.989a93.834 93.834 0 0 0-8.325-.41c-1.405 0-2.624.356-3.657 1.066-1.032.71-1.685 1.95-1.958 3.716l-.461 2.915v-.003L41.96 52.218l4.834.002ZM90.739 35.863l.63-4.017H79.467a1.979 1.979 0 0 0-1.95 1.658L77.1 36.08h7.53L75.182 48.13l-.63 3.988h12.203a1.979 1.979 0 0 0 1.951-1.657l.416-2.578H81.32l9.42-12.02ZM107.132 31.846H95.231a1.98 1.98 0 0 0-1.951 1.658l-.417 2.577h7.53L90.946 48.13l-.63 3.988h12.203a1.977 1.977 0 0 0 1.951-1.657l.416-2.578h-7.804l9.418-12.022.632-4.015Z" />
      </g>
      <path
        fill="#fff"
        d="m130.777 43.209 1.039-3.962 1.039 3.962h-2.078ZM148.508 45.206c-.351 0-.789-.07-1.089-.188V39.14a3.347 3.347 0 0 1 1.089-.188c1.521 0 2.034.958 2.034 2.885v.482c0 1.878-.47 2.886-2.034 2.886ZM156.156 39.128v2.103h1.402c.738 0 1.158-.42 1.158-1.133 0-.757-.464-1.145-1.352-1.145-.401 0-.895.069-1.208.175ZM156.156 45.03c.344.12.77.175 1.208.175 1.17 0 1.746-.425 1.746-1.32 0-.795-.47-1.264-1.277-1.264h-1.677v2.41ZM166.013 45.206c-1.133 0-1.777-.758-1.777-2.116v-2.034c0-1.352.644-2.103 1.777-2.103s1.765.751 1.765 2.103v2.034c0 1.358-.638 2.115-1.765 2.115Z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M121.244 31a7.1 7.1 0 0 0-6.936 5.583L111 51.703h66.747a7.102 7.102 0 0 0 6.937-5.583L187.991 31h-66.747Zm2.868 15.689c2.021 0 3.235-.958 3.235-2.572 0-1.265-.826-1.922-2.39-2.704l-.645-.326c-.663-.319-1.001-.682-1.001-1.164 0-.65.569-1.02 1.552-1.02.513 0 1.12.075 1.646.225l.206-1.17c-.701-.325-1.433-.488-2.309-.488-1.89 0-3.054.957-3.054 2.522 0 1.195.644 1.903 2.015 2.585l.607.3c.945.457 1.421.751 1.421 1.32 0 .695-.626 1.058-1.828 1.058-.569 0-1.264-.106-1.921-.275l-.213 1.177c.814.325 1.646.532 2.679.532Zm3.849-.12h2.021l.507-1.883h2.654l.507 1.884h2.021l-2.491-8.981h-2.735l-2.484 8.98Zm13.938-3.435v-5.545h1.852v8.98h-1.877l-3.224-5.544v5.545h-1.858v-8.981h1.877l3.23 5.545Zm6.434 3.555c3.079 0 4.155-1.584 4.155-4.369v-.482c0-2.779-1.089-4.368-4.155-4.368-.958 0-1.947.138-2.867.4v8.418c.945.27 1.928.4 2.867.4Zm12.729-2.623c0 1.697-1.389 2.623-3.905 2.623-.964 0-1.99-.144-2.954-.413V37.87a11.53 11.53 0 0 1 2.892-.4c2.296 0 3.579.851 3.579 2.39 0 .908-.469 1.703-1.17 1.966.939.219 1.558 1.114 1.558 2.24Zm4.951 2.623c2.447 0 3.818-1.546 3.818-4.319v-.588c0-2.722-1.415-4.312-3.818-4.312-2.41 0-3.824 1.59-3.824 4.312v.588c0 2.773 1.371 4.319 3.824 4.319Zm6.715-.12h-2.077l2.052-4.424-2.015-4.556h2.072l1.502 3.555 1.502-3.555h2.071l-2.015 4.556 2.047 4.425h-2.078l-1.527-3.305-1.534 3.305Z"
        clipRule="evenodd"
      />
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M41.956 31.846h65.176V52.22H41.956z" />
        </clipPath>
      </defs>
    </svg>
  )
}
export default FazzBusinessSandboxLogo
